import { render, staticRenderFns } from "./kv-html-renderer.vue?vue&type=template&id=1334661c&scoped=true"
import script from "./kv-html-renderer.vue?vue&type=script&lang=js"
export * from "./kv-html-renderer.vue?vue&type=script&lang=js"
import style0 from "./kv-html-renderer.vue?vue&type=style&index=0&id=1334661c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1334661c",
  null
  
)

export default component.exports